import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ALAsightunseenPOST, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction";
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react";
import { toast } from "react-toastify";
const ALAsightunseen = ()=>{

const {id,user}: any  = useParams()
const componentRef = useRef();
const [loader,setloading] = useState(false)
  const [sightunseen,setSightUnseen] = useState({
    offer_id :id,
    property_address :"",
    property_contract_date :null,
    seller_name :"",
    buyer_name :"",
    seller1_signature :"",
    seller1_signature_date :null,
    seller2_signature :"",
    seller2_signature_date :null,
    buyer1_signature :"",
    buyer1_signature_date :null,
    buyer2_signature :"",
    buyer2_signature_date :null,
    seller_agent_signature :"",
    seller_agent_signature_date :null,
    buyer_agent_signature :"",
    buyer_agent_signature_date :null
    
  })
  const [canvasmodal, setCanvasModal] = useToggle(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [offerdetails, setOfferDetails]:any = useState({});
  const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
      offerid: "",
      document_name: "",
      image_base64: "",
      sign_role: 1
  })
  // @ts-ignore
  const val = useSelector((state) => state?.new?.signset)
  //   const seller_date = ()=>{const d =  new Date();setLeadBasePaint({...leadbasepaint,seller1_date: new Date()})  }

  const printf = async () => {
      // window.print()
      handlePrint()

  }

  useEffect(()=>{
    if(val){
      if(user == "seller"){
        setSightUnseen({ ...sightunseen, seller1_signature: val })
      }
      if(user == "client"){
        setSightUnseen({ ...sightunseen, buyer1_signature: val })
      }
    }
    },[val])

  const send = async()=>{
    setloading(true)
    if(user === "seller"){

      if(sightunseen?.seller1_signature){
        let res = await ALAsightunseenPOST(sightunseen)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
        
      }
    }
    else if(user === "client"){
   
      if(sightunseen?.buyer1_signature){
        let res = await ALAsightunseenPOST(sightunseen)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    }
    else{
      const run = async () => { return setSightUnseen({ ...sightunseen, seller_agent_signature: val }) }
      await run()
      if(sightunseen?.seller_agent_signature){
        let res = await ALAsightunseenPOST(sightunseen)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      } 
    }
    setloading(false)
  }

  useEffect(()=>{
    (async function(){
      let offerdetails = await getSavedOfferDetails(id)
      setOfferDetails(offerdetails[0])
      setSightUnseen({...sightunseen, property_address:offerdetails[0]?.propertyAddress})
      const res =await getexternaldocuments(id,"sightunseen")
      setSightUnseen({...sightunseen,
        property_address :res?.data?.property_address,
    property_contract_date :res?.data?.property_contract_date,
    seller_name :res?.data?.seller_name,
    buyer_name :res?.data?.buyer_name,
    seller1_signature :res?.data?.seller1_signature,
    seller1_signature_date :res?.data?.seller1_signature_date,
    seller2_signature :res?.data?.seller2_signature,
    seller2_signature_date :res?.data?.seller2_signature_date,
    buyer1_signature :res?.data?.buyer1_signature,
    buyer1_signature_date :res?.data?.buyer1_signature_date,
    buyer2_signature :res?.data?.buyer2_signature,
    buyer2_signature_date :res?.data?.buyer2_signature_date,
    seller_agent_signature :res?.data?.seller_agent_signature,
    seller_agent_signature_date :res?.data?.seller_agent_signature_date,
    buyer_agent_signature :res?.data?.buyer_agent_signature,
    buyer_agent_signature_date :res?.data?.buyer_agent_signature_date
      }) 

    }
  
  )()
  },[])

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

    return (
        <>
        <table
  style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 20 }} ref={componentRef}
>
  <tbody>
    <tr>
      <td>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "90%" }}>
                <img
                  style={{ width: 250 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                />
              </td>
              <td>
                <img
                  style={{ width: 30 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                  alt=""
                />
                <img
                  style={{ width: 50 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 15 }}>
        <span style={{ fontSize: 20, fontWeight: 700 }}>
          Sight Unseen Addendum
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px" }}>
        <span>
          <span style={{ fontWeight: 600, color: "#3b0083" }}>
            Property Address:{" "}
          </span>
          <input
            type="input"
            value={sightunseen?.property_address}
            onChange={(e)=>setSightUnseen({...sightunseen,property_address:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "85%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px" }}>
        <span>
          <span style={{ fontWeight: 600, color: "#3b0083" }}>
            Purchase Contract Reference Date:
          </span>
          <input
            type="date"
            value={sightunseen?.property_contract_date}
            onChange={(e)=>setSightUnseen({...sightunseen,property_contract_date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "70%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px" }}>
        <span>
          <span style={{ fontWeight: 600, color: "#3b0083" }}>
            Seller(s) Name:
          </span>
          <input
            type="text"
            value={sightunseen?.seller_name }
            onChange={(e)=>{setSightUnseen({...sightunseen,seller_name:e.target.value})}}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "85%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px" }}>
        <span>
          <span style={{ fontWeight: 600, color: "#3b0083" }}>
            Buyer(s) Name:
          </span>
          <input
            type="text"
            value={offerdetails?.leadName}
            // onChange={(e)=>setSightUnseen({...sightunseen,buyer_name:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "85%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px" }}>
        <span>
          Buyer(s) understand and accept that Buyer(s) is/are buying the
          property specified in the above-referenced purchase agreement without
          ever having visited or seen the property. Buyer(s) will be provided
          ample time to do all inspections agreed upon in the purchase
          agreement, as well as time to review all documents pertaining to the
          purchase of the subject property
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px" }}>
        <span>
          Buyer(s) will hold Seller(s) harmless from any/all responsibility for
          any deficiencies found in the property after the sale has closed and
          Buyer(s) have taken possession of the property. This does not include
          repairs requested and agreed upon by the parties in the purchase
          documents
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px" }}>
        <span>
          Buyer(s) hereby agree to release and hold harmless Milford Real Estate
          Group, its brokers, agents, and assigns from any and all claims of any
          nature or kind whatsoever arising from or connected with conveyance of
          the subject property
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px" }}>
        <span>
          Buyer(s) further acknowledge that Milford Real Estate Group has
          recommended that the property be inspected by a professional home
          inspector. Failure of the Buyer(s) to follow this advice is understood
          by Buyer(s) to result in possible negative impacts on the property’s
          value, usability, desirability, and enjoyment of said property
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
              <span style={{paddingRight: ".5rem"}}>Seller </span>
                <span>
                  <img
                    src={user === "seller" ? (val || sightunseen?.seller1_signature) : sightunseen?.seller1_signature}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        
                      </td>
                      <td>
                        <input type="date" 
                        value={sightunseen?.seller1_signature_date ? sightunseen?.seller1_signature_date  : (user === "seller" && val || sightunseen?.seller1_signature) ? new Date().toISOString().split('T')[0] : ""}
                        onChange={(e)=>setSightUnseen({...sightunseen,seller1_signature_date:e.target.value})}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
              <span style={{paddingRight: ".5rem"}}>Buyer</span>
                <span>
                  <img
                  src={user === "client" ? (val || sightunseen?.buyer1_signature) : sightunseen?.buyer1_signature}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        
                      </td>
                      <td>
                        <input type="date" 
                        value={sightunseen?.buyer1_signature_date ? sightunseen?.buyer1_signature_date : (user === "client" && val || sightunseen?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
                        onChange={(e)=>setSightUnseen({...sightunseen,buyer1_signature_date:e.target.value})}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
              <span style={{paddingRight: ".5rem"}}>Seller </span>
                <span>
                  <img
                    src={sightunseen?.seller2_signature}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        
                      </td>
                      <td>
                        <input type="date" 
                        value={sightunseen?.seller2_signature_date}
                        onChange={(e)=>setSightUnseen({...sightunseen,seller2_signature_date:e.target.value})}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
              <span style={{paddingRight: ".5rem"}}>Buyer </span>
                <span>
                  <img
                  src={sightunseen?.buyer2_signature}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "99%"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        
                      </td>
                      <td>
                        <input type="date" 
                        value={sightunseen?.buyer2_signature_date}
                        onChange={(e)=>setSightUnseen({...sightunseen,buyer2_signature_date:e.target.value})}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
              <span style={{paddingRight: ".5rem"}}>Seller'Agent </span>
                <span>
                  <img
                    src={user === "agent" ? (val || sightunseen?.seller_agent_signature) : sightunseen?.seller_agent_signature}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        
                      </td>
                      <td>
                        <input type="date" 
                        value={sightunseen?.seller_agent_signature_date}
                        onChange={(e)=>setSightUnseen({...sightunseen,seller_agent_signature_date:e.target.value})}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
              <span style={{paddingRight: ".5rem"}}>Buyer'Agent</span>
                <span>
                  <img
                    
                    src={sightunseen?.buyer_agent_signature}
  
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        
                      </td>
                      <td>
                        <input type="date" 
                         value={sightunseen?.buyer_agent_signature_date}
                         onChange={(e)=>setSightUnseen({...sightunseen,buyer_agent_signature_date:e.target.value})}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "20px 0px" }}>
        <span>
          Other provisions: Earnest deposit to be delivered within (5) business
          days
        </span>
      </td>
    </tr>
  </tbody>
</table>
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>
<Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
        </>
    )
}

export default ALAsightunseen